import React from 'react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Box, Typography, Paper, List, ListItem, ListItemText } from '@mui/material';
import StockorderproductInfo from './StockorderproductInfo';

const mockProducts = [
  { id: 1, name: 'Product A', qty: 10, price: 100 },
  { id: 2, name: 'Product B', qty: 5, price: 200 },
];

export default function StockorderProductList({stockOrderId}) {
    const {stockorderproductList} = useSelector((state) => state.manufslice);
    const [productListUnderStockOrder, setproductListUnderStockOrder] = useState(stockorderproductList.filter(product => product.stockorderid === stockOrderId));

useEffect(() => {
    console.log('stockOrderId:', stockOrderId);
  }, []);
  return (
    <Grid container direction="row" sx={{ width: '100%' }}>
      {productListUnderStockOrder.map((product, idx) => (
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{
            backgroundColor: 'white',
            paddingBottom: idx === productListUnderStockOrder.length - 1 ? 0 : 0.15,
            marginBottom: 1
          }}
          key={product.id}
        >
          <StockorderproductInfo stockorderproductObj={product} />
        </Grid>
      ))}
    </Grid>
  );
}